/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import rtlPlugin from 'stylis-plugin-rtl';
import { StyleSheetManager } from 'styled-components';
import { ModelManager } from '@adobe/aem-spa-page-model-manager';
import { version as globalStylesVersion } from '@marriott/global-styles/package.json';
import path from 'path';
import '@glidejs/glide/src/assets/sass/glide.core.scss';
import '@glidejs/glide/src/assets/sass/glide.theme.scss';
import '../styles/brands.scss';

import { defineComponentMapping } from '../import-components';
import { useSessionDataStore } from '@marriott/mi-homepage-components-store';
import { UserSessionProvider } from '@marriott/mi-headless-utils';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

path.resolve('./next.config.js');
declare global {
  interface Window {
    jQuery: unknown;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $: any;
    deployedEnvType: string;
  }
}

if (process.env.NODE_ENV !== 'test') {
  ModelManager.initializeAsync();
}

const App = function (props) {
  console.log('App.tsx props', props);
  const { Component, pageProps } = props;
  const rtlPluginTs = (...args: unknown[]) => {
    return rtlPlugin(args[0] as number, args[1] as string);
  };
  const { resolvedUrl, model, isAuthorMode, NEXT_GLOBAL_ASSET_PREFIX } = pageProps;
  const { setSessionData, setHeadersData, setEnvVariablesData } = useSessionDataStore();
  const allowedComponents = model?.cqItems?.root?.[':items']?.responsivegrid?.allowedComponents?.components;
  const mergeEnvVars = useClientEnvVarsStore((state: any) => state.mergeEnvVars);
  // adding dummy variable to fulfill empty env vars condition in session provider.
  // This needs to read from environemnt variables once websdk is enabled for this product

  mergeEnvVars({
    NEXT_PUBLIC_SUBMIT_SEARCH_URL: pageProps?.NEXT_PUBLIC_SUBMIT_SEARCH_URL,
    NEXT_PUBLIC_AVAILABILITY_SEARCH_URL: pageProps?.NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
    GOOGLE_MAP_API_KEY: pageProps?.GOOGLE_MAP_API_KEY,
    NEXT_PUBLIC_ENABLE_WEBSDK: 'false',
  });
  useEffect(() => {
    setSessionData(pageProps.sessionData);
    setHeadersData(pageProps.headersData);
    setEnvVariablesData({
      submitSearchUrl: process.env.NEXT_PUBLIC_SUBMIT_SEARCH_URL,
      availabilitySearchUrl: process.env.NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
      googleMapApiKey: process.env.GOOGLE_MAP_API_KEY,
    });

    // Temp code we need to remove once ARM release happened
    // On common header there are help and langulage selector icons are getting hidden to show them added below fix
    const interval = setTimeout(() => {
      const commonHeader = document.getElementsByClassName('brands-common-header');
      if (commonHeader.length > 0) {
        const elementToModify = document.getElementsByClassName('first-set-list-items');
        if (elementToModify.length) {
          for (let i = 0; i < elementToModify.length; i++) {
            elementToModify[i].classList.remove('d-none');
          }
          clearTimeout(interval); // Stop checking once found
        }
      }
    }, 500); // Check after 500ms

    if (isAuthorMode) {
      let remoteURL: URL | string;
      try {
        remoteURL = new URL(document.body.dataset.remoteUrl || '');
        remoteURL = remoteURL.origin;
      } catch (e) {
        remoteURL = '';
      }
      const assetUrl = `${
        process.env['NEXT_PUBLIC_ASSET_DOMAIN'] || remoteURL || 'https://www.marriott.com'
      }${NEXT_GLOBAL_ASSET_PREFIX}`;

      const globalStyle = document.createElement('link');

      globalStyle.rel = 'stylesheet';
      globalStyle.href =
        assetUrl +
        (model?.rtlEnable == 'true'
          ? `global-styles/${globalStylesVersion}/marriot.global.rtl.css`
          : `global-styles/${globalStylesVersion}/marriot.global.css`);
      document.head.appendChild(globalStyle);
    }

    return () => clearTimeout(interval);
  }, []);

  defineComponentMapping(allowedComponents, resolvedUrl, isAuthorMode, pageProps);

  Object.defineProperty(rtlPluginTs, 'name', { value: 'rtlPluginMonorepo' });
  return (
    <StyleSheetManager stylisPlugins={pageProps?.model?.rtlEnable === 'true' ? [rtlPluginTs] : []}>
      <UserSessionProvider pageProps={pageProps}>
        <Component {...pageProps} />
      </UserSessionProvider>
    </StyleSheetManager>
  );
};

export default App;
